function updateColorsHash(colors = []) {
    document.location.hash = colors
      .map((elem) => {
        return elem.toString().slice(1);
      })
      .join("-");
  }
  export default updateColorsHash